import React from "react";
import { ButtonDefault } from "./Button.elements";

export default function Button({ text }: any): JSX.Element {
  return <ButtonDefault>{text}</ButtonDefault>;
}
